export const environment = {
  production: false,
  apiBaseUrl: 'https://portal.avs-digital.de/tls2-api',
  defaultGroupId: 3,
};
